import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-surface mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-12 py-16">
        <p className="font-display text-[16vw] md:text-[9vw] leading-none uppercase text-outline select-none">Coleman</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mt-12 font-mono text-xs uppercase tracking-widest text-zinc-500">
          <div>
            <p className="text-kinetic mb-4">Shop</p>
            <div className="space-y-2 flex flex-col">
              <Link to="/shop" className="hover:text-white transition-colors">All Apparel</Link>
              <Link to="/shop?category=Tees" className="hover:text-white transition-colors">Tees</Link>
              <Link to="/shop?category=Hoodies" className="hover:text-white transition-colors">Hoodies</Link>
              <Link to="/shop?category=Outerwear" className="hover:text-white transition-colors">Outerwear</Link>
            </div>
          </div>
          <div>
            <p className="text-kinetic mb-4">Support</p>
            <div className="space-y-2 flex flex-col">
              <Link to="/track" className="hover:text-white transition-colors">Track Order</Link>
              <Link to="/lookbook" className="hover:text-white transition-colors">Lookbook</Link>
              <Link to="/account" className="hover:text-white transition-colors">My Account</Link>
            </div>
          </div>
          <div>
            <p className="text-kinetic mb-4">Studio</p>
            <p className="leading-relaxed normal-case tracking-normal text-zinc-500">
              7899 County Road 296 E<br />Kilgore, TX 75662<br />(903) 220-1884<br />colemancustom1@gmail.com
            </p>
          </div>
          <div>
            <p className="text-kinetic mb-4">Spec</p>
            <p className="leading-relaxed normal-case tracking-normal text-zinc-500">
              480gsm fleece · 10k stitch embroidery · water-based inks · no minimums
            </p>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 font-mono text-[11px] uppercase tracking-widest text-zinc-600">
          <span>© 2026 Coleman Customs. All rights reserved.</span>
          <span>Raw apparel. Built to order.</span>
        </div>
      </div>
    </footer>
  );
}
